import React, { useEffect, useState } from 'react'
import { ButtonHLPure, CardMenuHLPure, FilterHLPure, SimpleLoading } from '../../pures';
import { Container, Grid } from '@material-ui/core';
import { LocalStorageService, StatusApplicationTypeService, TemplateService } from '../../../services';
import { useLocation } from 'react-router-dom';
import './standard-templates.view.css'
import { useTranslation } from 'react-i18next';

const StandardTemplatesView = (props) => {
    const {
        onBack,
        onSelect,
        toggleErrorRequesting,
        changeRoute
    } = props;

    const { t } = useTranslation()
    const url = process.env.REACT_APP_MIFIRMA_API;
    const templateService = new TemplateService(url);
    const statusApplicationTypeService = new StatusApplicationTypeService(url);
    const localStorageService = new LocalStorageService();

    let location = useLocation();
    let urlContract = location.pathname

    const [loading, setLoading] = useState(true)
    const [templates, setTemplates] = useState([]);

    const [selectedType, setSelectedType] = useState(0);
    const [templateTypes, setTemplateTypes] = useState([]);

    const loadTemplates = async () => {
        setLoading(true);
        const token = localStorageService.getLocalStorageItem("token").idToken;

        try {
            let typesResponse = await statusApplicationTypeService.getStatusApplicationType(token, process.env.REACT_APP_STATUS_APPLICATION_TYPE_STANDARD_CONTRACT)
            let templatesResponse = await templateService.getTemplatebyClientId(null, null, token);
            templatesResponse.sort((a, b) => a.statusApplicationType.id > b.statusApplicationType.id ? 1 : -1)
            setTemplates(templatesResponse)
            setTemplateTypes([{ id: 0, value: t("digitalContractDashboard.questionnaires.comboboxAllOption") }, ...typesResponse.data])
            setLoading(false);
        } catch (e) {
            setLoading(false);
            toggleErrorRequesting(true)
            setTimeout(() => {
                toggleErrorRequesting(false)
                onBack();
            }, 2000);
        }
    }

    useEffect(() => {
        loadTemplates();
    }, [])

    let filteredTemplates = [...templates]
    if (selectedType !== 0) {
        filteredTemplates = filteredTemplates.filter(item => item.statusApplicationType.id == selectedType)
    }


    if (loading) return <SimpleLoading />

    return (
        <Grid item xs={12} className="questionnaireAdministration-standardTemplatesView"
        >
            <Container>
                <Grid container spacing={3}>
                    <Grid item xs={12} container justify='flex-end'>
                        <FilterHLPure
                            options={templateTypes}
                            nameOption="value"
                            valueItem="id"
                            onFilterChange={(e) => setSelectedType(parseInt(e.target.value))}
                        />
                    </Grid>
                    <Grid item xs={12} className="questionnaireAdministration-standardTemplatesView-list">
                        {
                            filteredTemplates.map(template => <CardMenuHLPure
                                key={template.id}
                                img={template.icon}
                                title={template.name}
                                text={template.description}
                                onClick={() => {
                                    onSelect(template);
                                    onBack();
                                }}
                            />)
                        }
                    </Grid>
                    {/* <Grid item xs={12} container justify='flex-end'>
                        <ButtonHLPure nameBtn={"Regresar"} onClickBtn={(urlContract === "/digital-contract/standar-contracts" && changeRoute) ? () => changeRoute(0) : onBack} />
                    </Grid> */}
                </Grid>
            </Container>
        </Grid>
    )
}

export default StandardTemplatesView